'use client'

import Image from 'next/image'
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'

export default function ScrollMorphMedia({
  src,
  alt,
  label,
  className = 'min-h-[34rem]',
  priority = false,
}: {
  src: string
  alt: string
  label?: string
  className?: string
  priority?: boolean
}) {
  const ref = useRef<HTMLDivElement>(null)
  const reduceMotion = useReducedMotion()
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 0.95', 'end 0.1'],
  })
  const rotateX = useTransform(scrollYProgress, [0, 0.5, 1], reduceMotion ? [0, 0, 0] : [10, 0, -4])
  const scale = useTransform(scrollYProgress, [0, 0.52, 1], reduceMotion ? [1, 1, 1] : [0.9, 1, 0.96])
  const y = useTransform(scrollYProgress, [0, 1], reduceMotion ? [0, 0] : [48, -32])
  const borderRadius = useTransform(scrollYProgress, [0, 0.55, 1], ['10rem 10rem 2rem 2rem', '2rem', '2rem 2rem 10rem 10rem'])

  return (
    <div ref={ref} className={`relative ${className}`} style={{ perspective: '1200px' }}>
      <motion.div
        style={{ rotateX, scale, y, borderRadius }}
        className="absolute inset-0 overflow-hidden border border-white/12 bg-[#10374d] shadow-[0_35px_90px_rgba(0,0,0,0.38)]"
      >
        <Image
          src={src}
          alt={alt}
          fill
          sizes="(max-width: 1024px) 100vw, 48vw"
          className="object-cover"
          priority={priority}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#10374d]/90 via-transparent to-transparent" />
        <div className="absolute inset-5 rounded-[inherit] border border-[#f1a54e]/25" />
        {label && (
          <div className="absolute inset-x-7 bottom-7 border-s-4 border-[#f1a54e] bg-[#10374d]/72 p-5 backdrop-blur-md">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#f1a54e]">{label}</p>
          </div>
        )}
      </motion.div>
    </div>
  )
}
